<template>
  <header class="m-pc-header">
    <div class="header-left">
      <div
        v-if="
          this.$route.path.indexOf('/pc/meetingInfo') > -1 &&
            template.meetingInfo.logo.display.value
        "
        class="logo meetingInfo"
      >
        <a @click="toNewPager(template.meetingInfo.logo_href.text.value)">
          <img v-bind:src="template.meetingInfo.logo.src.value" alt="" />
        </a>
      </div>
      <div
        v-if="
          this.$route.path === '/pc/meeting' &&
            template.meeting.logo.display.value
        "
        class="logo meeting"
      >
        <a @click="toNewPager(template.meeting.logo_href.text.value)">
          <img v-bind:src="template.meeting.logo.src.value" alt="" />
        </a>
      </div>
      <div class="info">
        <div class="name" :title="webinarInfo.title">
          {{ webinarInfo.title }}
        </div>
        <div class="text">
          <span
            class="key"
            v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
            >会议时间：</span
          >
          <span
            class="value"
            v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
            >{{ time }}</span
          >
          <span class="key">主办方：</span>
          <span class="value">{{ webinarInfo.sponsor }}</span>
        </div>
      </div>
    </div>
    <div class="header-right">
      <div
        class="user-info"
        v-if="
          isLogin &&
            userInfo &&
            userInfo.name &&
            userInfo.name != '' &&
            webinarInfo.needLogin !== false
        "
      >
        <span class="user-name" @click="toUserCenter">{{ userInfo.name }}</span>
        <span
          class="icon icontemp logout-a"
          @click="logout(webinarInfo)"
        ></span>
      </div>
      <div
        class="user-info"
        v-if="!isLogin && webinarInfo.needLogin && !webinarInfo.unLimit"
      >
        <span class="user-name" @click="toLogin(webinarInfo)">登录</span>
      </div>
      <div class="img-icon">
        <span class="icon icontemp iphone"></span>
        <div class="code">
          <div id="qr-code"></div>
          手机扫码观看
        </div>
      </div>
      <div class="img-icon" v-show="webinarInfo.posterStatus == '1'">
        <span class="icon icontemp shaerd"></span>
        <div class="share-info" id="share">
          <div class="share">
            <div class="share-h bdsharebuttonbox" data-tag="share_1">
              <div class="share-h-l">
                <div class="invite">邀请朋友一起来观看</div>
                <a
                  href="#"
                  class="share-con share01"
                  data-cmd="tsina"
                  title="微博"
                ></a>
                <a
                  href="#"
                  class="share-con share02"
                  data-cmd="sqq"
                  title="QQ"
                ></a>
                <a
                  href="#"
                  class="share-con share03"
                  data-cmd="qzone"
                  title="QQ空间"
                ></a>
              </div>
              <div class="share-h-r">
                <div id="qr-code2"></div>
                微信扫码分享
              </div>
            </div>
            <div class="share-b">
              <input
                id="shareUrl"
                type="text"
                v-model="posterShareUrl"
                readonly
              />
              <button
                id="copy"
                class="btn btn-copy"
                data-clipboard-target="#shareUrl"
                @click="copyLink"
              >
                复制
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Clipboard from "clipboard";
import { $subscriber, URLS } from "fire-wind-water";
import moment from "moment";
import { logout, goToLogin, goToSignUp } from "../../common/joinMeeting";
import QRCode from "qrcodejs2";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import URL from "../../assets/conf/setting.json";
export default {
  name: "Header",
  mixins: [mixinsTemplate],
  data() {
    return {
      time: "",
      webinarInfo: {},
      userInfo: {},
      shareUrl: "",
      userName: "",
      isLogin: false,
      isMeetingInfo:
        window.location.href.indexOf("meetingInfo") > -1 ? true : false,
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false, //静态链接回放状态
      posterShareUrl: ""
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let qrcode1 = "";

      this.isLogin = false;
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        this.time = moment(data.startTime).format("YYYY-MM-DD");
        this.shareUrl = this.webinarInfo.unLimit
          ? this.webinarInfo.unLimitUrl
          : this.webinarInfo.shortUrl;
        document.getElementById("qr-code").innerHTML = "";
        qrcode1 = new QRCode("qr-code", {
          width: 100,
          height: 100,
          text: this.webinarInfo.unLimit
            ? this.webinarInfo.unLimitUrl
            : this.webinarInfo.shortUrl, //任意内容
          colorDark: "#000",
          colorLight: "#fff"
        });
      });
      $subscriber.subscribe("userInfo", data => {
        if (data.markCode && data.markCode !== "") {
          if (
            this.posterShareUrl &&
            this.posterShareUrl.indexOf("markCode") == -1
          ) {
            let url = this.posterShareUrl.replace(
              "#/",
              "&markCode=" + data.markCode + "#/"
            );
            this.posterShareUrl = url;
          }
        }
        if (data.name.length === 2) {
          data.name = data.name.slice(0, 1) + " " + data.name.slice(1);
        }
        this.userInfo = data;
        this.isLogin = data.isLogin;
        this.getPosterUrlCode();
      });
      $subscriber.subscribe("posterShareUrl", data => {
        const userInfo = window.$sk.webinar.get().user;
        this.posterShareUrl = data;
        if (userInfo.markCode) {
          this.posterShareUrl = this.posterShareUrl.replace(
            "#/",
            "&markCode=" + userInfo.markCode + "#/"
          );
        }
        this.getPosterUrlCode();
      });
      $subscriber.on("setUserName", data => {
        this.isLogin = true;
      });
      window._bd_share_config = {
        common: {
          bdSnsKey: {
            tsina: "sina",
            tqq: "qq",
            t163: "163",
            tsohu: "sohu"
          },
          bdText: "",
          bdMini: "1",
          bdMiniList: false,
          bdPic: "",
          bdStyle: "0",
          bdSize: "32"
        },
        share: {}
      };
      window._bd_share_main.init();
    },
    logout(webinar) {
      this.isLogin = false;
      return logout(webinar);
    },
    getPosterUrlCode() {
      let qrcode2 = "";
      document.getElementById("qr-code2").innerHTML = "";
      qrcode2 = new QRCode("qr-code2", {
        width: 120,
        height: 120,
        text: this.posterShareUrl, //任意内容 ko data.posterShareUrl
        colorDark: "#000000",
        colorLight: "#ffffff"
      });
    },
    toLogin(webinar) {
      return goToLogin(webinar, "", function(loginUrl) {
        if (webinar.needRegistration && !webinar.isRegistration) {
          //需要报名
          goToSignUp(webinar, function(registrationUrl) {
            window.$sk.goto(
              loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(registrationUrl)
            );
          });
        } else {
          //已报名或无需报名
          window.$sk.goto(
            loginUrl +
              "sourceKey=" +
              URLS.getURL("sourceKey") +
              "&backUrl=" +
              encodeURIComponent(window.location.href)
          );
        }
      });
    },
    toNewPager(href) {
      if (href && href != "") {
        window.open(href);
      }
    },
    toUserCenter() {
      window.$sk
        .goto(
          URL.template.usercenterUrl +
            "index.html?tenantId=" +
            this.webinarInfo.tenantId +
            "&schemaId=" +
            this.webinarInfo.schemaId +
            "&memberFormId=" +
            this.webinarInfo.registrationFormId,
          true
        )
        .subscribe(res => {
          window.open(res);
        });
    },
    copyLink() {
      let _this = this;
      let clipboard = new Clipboard("#copy");
      clipboard.on("success", function() {
        _this.$toast("复制成功");
      });
      clipboard.on("error", function() {
        _this.$toast("复制失败");
      });
    }
  }
};
</script>

<style scoped></style>
